<div class="creator-carousel-container" *ngIf="rosters && rosters.length">
  <div class="creator-carousel-wrapper">
    <div class="scroll-arrow left" (click)="scrollLeft()">◀</div>
    <div class="creator-carousel-items-container" #carousel>
      <div *ngFor="let roster of rosters" class="creator-carousel-item">
        <app-creator-tile [roster]="roster"></app-creator-tile>
      </div>
    </div>
    <div class="scroll-arrow right" (click)="scrollRight()">▶</div>
  </div>
</div>
